export const ColumnWidths = {
  COLOR: '3px',
  POSITION: '13px',
  TEAM_NAME: 'minmax(0, 1fr)',
  MATCHES_PLAYED: '25px',
  WINS: '18px',
  DRAWS: '18px',
  LOSSES: '18px',
  POINTS: '25px',
  RECENT_FORM: '56px',
};
